import { generateUUID } from "../../../utils/constants"
import { CHATBOT_CHANNEL_NAME } from "../../../pages/ruleBasedInbox/channelConstants"
import RenderCustomOption from "../../global/autocomplete/renderCustomOption";

export const defaultConditionValueObject = {
    chatbot_step_deployment_trigger_data_id: "", 
    condition_group: null,
}

export const initialCreateNewFlowObject = {
    chatbot_name: "",
    channel_id: 0,
    chatbot_type_id: 0,
    chatbot_channel_configuration: null, 
    chatbot_step_deployment_trigger_data: [defaultConditionValueObject, {
        chatbot_step_deployment_trigger_data_id: "", 
        condition_group: {
            condition_type: "static_value_check", 
            flag_advanced_condition: false, 
            condition_values: [],
        }
    }], 
    chatbot_thread_timeout_config: {
        chatbot_thread_timeout_config_id: generateUUID(), 
        chatbot_id: "", 
        timeout_type: "relative_to_last_message", 
        timeout_duration: {
            hour: "24",
            min: "0", 
            day: "", 
            sec: "",
        }
    }
}

export const workflowCreationListData = [
    {
        integration_list_id: 1,
        integration_list_name: "WhatsApp"
    },
    {
        integration_list_id: 2,
        integration_list_name: "Facebook Messenger"
    },
    {
        integration_list_id: 3,
        integration_list_name: "Instagram"
    },
    {
        integration_list_id: 4,
        integration_list_name: "Slack"
    }
]

export const ALLOWED_INTEGRATION_CHANNELS = [
    {
        channel_name: "WhatsApp",
        is_disabled: false,
    },
    {
        channel_name: "Facebook",
        is_disabled: true,
    },
    {
        channel_name: "Instagram",
        is_disabled: false,
    }
]

export const renderIntegrationOption = (props, option, integrationType = CHATBOT_CHANNEL_NAME.WHATSAPP) => {
    
    const isInstagram = (integrationType?.toLowerCase() === CHATBOT_CHANNEL_NAME.INSTAGRAM?.toLowerCase());
    
    const optionLabelKey = isInstagram ? "meta_integration_instagram_id" : "waba_id";
    const optionName = isInstagram ? option?.instagram_account_name : option?.waba_name;
    
    const isCustomOption = Number(option?.[optionLabelKey]) === -1 || Number(option?.waba_id) === -1;

    const optionForRender = {
        ...option,
        [optionLabelKey]: isCustomOption ? -1 : option?.[optionLabelKey],
    };

    return (
        <RenderCustomOption
            autocompleteRenderOptionProps={props}
            option={optionForRender}
            customOptionName={`New ${integrationType} Business`}
            optionName={optionName}
            optionLabelKey={optionLabelKey}
            onClickOfCustomOption={() => {
                window.open(`${window.location.origin}/channels/viewintegration/${integrationType?.toLowerCase()}`, "_blank");
            }}
        />
    );
};
